import { render, staticRenderFns } from "./SayHello.vue?vue&type=template&id=22c998e4&scoped=true&"
import script from "./SayHello.vue?vue&type=script&lang=js&"
export * from "./SayHello.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c998e4",
  null
  
)

component.options.__file = "SayHello.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardText,
  VContainer,
  VFlex,
  VLayout,
})
